module.exports = __webpack_public_path__ + "img/zoom.909592b0.svg";